<template>
  <tr>
    <td colspan="2">
      <tr>
        <td align="left" v-if="customer">
          <h3 style="color: #00638c; font-size: 20px; text-align: left; margin-bottom:0; margin-top: 20px">
            {{ customer.first_name }} {{ customer.last_name }}, {{ $t('confirmation.view.your_booking') }}.</h3>
        </td>
      </tr>
      <tr>
        <td height="10" style="line-height:0px; font-size:0px;">&nbsp;</td>
      </tr>
      <tr>
        <td>
          <span
            style="font-weight: normal; font-size: 14px; color:#000000; text-align: left;"
          >{{ $t('confirmation.view.please_read') }}</span>
        </td>
      </tr>
      <tr>
        <td height="10" style="line-height:0px; font-size:0px;">&nbsp;</td>
      </tr>
    </td>
  </tr>
</template>

<script>
export default {
  name: "confirmation-view-intro",
  props: {
    customer: { type: Object, default: () => {} }
  }
};
</script>